import { FilterOption } from '../../../core/models/grid/filter-option';

/**
 * Constants related to applications (Form-601) and FRN Filings (Form-160) in the dashboard.
 */
export class DashboardConstants {
    static readonly SERVICES_HEADER_NAME = 'Services';
    static readonly APP_ID_PSCA_ID_HEADER_NAME = 'App ID/PSCA ID';
    static readonly CALL_SIGN_FILE_HEADER_NAME = 'Call Sign/File #';
    static readonly APPLICANT_TX_LOCATION_HEADER_NAME =
        'Applicant, TX Location';
    static readonly CUSTOMER_HEADER_NAME = 'Customer';
    static readonly STATUS_HEADER_NAME = 'Status';
    static readonly ACTION_HEADER_NAME = 'Action';
    static readonly SERVICE_SELECTION_HEADER_NAME = 'Service Selection';
    static readonly COORDINATOR_HEADER_NAME = 'Advisor';
    static readonly HANDED_OVER_TO_EWA_HEADER_NAME = 'Handed Over To EWA';
    static readonly LAST_MODIFIED_AT_HEADER_NAME = 'Updated';

    static readonly FRN_REQUEST_LABEL = 'FRN Request';
    static readonly FRN_REQUEST_VALUE = 'FRN_REQUEST';

    /**
     * The filter option for FRN Request applications in the Services filter dropdown.
     */
    static readonly FRN_REQUEST_FILTER_OPTION: FilterOption = {
        label: DashboardConstants.FRN_REQUEST_LABEL,
        value: DashboardConstants.FRN_REQUEST_VALUE,
        selected: false,
    };

    static readonly ALL_APPLICATIONS_FILTER_VALUE = 'all';
    static readonly ALL_APPLICATIONS_FILTER_LABEL = 'All Applications';

    static readonly WORK_IN_PROGRESS_FILTER_VALUE = 'work-in-progress';
    static readonly EWA_STAFF_WORK_IN_PROGRESS_FILTER_LABEL =
        'Work In Progress';
    static readonly CUSTOMER_WORK_IN_PROGRESS_FILTER_LABEL =
        'Work In Progress - Not Handed Over To EWA';

    static readonly COORDINATION_FILTER_VALUE = 'coordination';
    static readonly EWA_STAFF_COORDINATION_FILTER_LABEL = 'Coordination';
    static readonly CUSTOMER_COORDINATION_FILTER_LABEL = 'My Coordination';

    static readonly HANDED_OVER_TO_EWA_FILTER_VALUE = 'handed-over-to-ewa';
    static readonly HANDED_OVER_TO_EWA_FILTER_LABEL = 'Handed Over to EWA';

    static readonly GO_FILTER_VALUE = 'go';
    static readonly GO_FILTER_LABEL = 'Cevo Go';

    static readonly SUBMITTED_FILTER_VALUE = 'submitted';
    static readonly SUBMITTED_FILTER_LABEL = 'Submitted';

    static readonly FCC_RETURNED_FILTER_VALUE = 'fcc-returned';
    static readonly FCC_RETURNED_FILTER_LABEL = 'Notices of Return';

    static readonly OTHER_SERVICES_FILTER_VALUE = 'other';
    static readonly OTHER_SERVICES_FILTER_LABEL = 'Other Services';
}
